<template>
  <div class="code-box">
    <input
      type="text"
      inputmode="numeric"
      maxlength="1"
      v-for="(_, idx) in chars"
      v-bind:id="`fk-${idx + 1}`"
      v-bind:key="idx"
      v-bind:readonly="readonly"
      v-on:keyup="checkInput"
      v-on:click="selectInput"
      v-model.trim="chars[idx]"
      v-on:input="sendFull"
    />
  </div>
</template>

<script>
// https://github.com/claudiolcastro/vue-fake-input
// https://codesandbox.io/s/stoic-turing-44ii1?file=/src/components/CodeBox.vue

export default {
  name: 'CodeBox',

  props: {
    value: String,

    charCount: {
      type: Number,
      default: 4,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    autosend: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      chars: [],
    };
  },

  mounted() {
    this.chars = new Array(this.charCount).fill('');
  },

  computed: {
    fullCode() {
      return this.chars.join('');
    },
  },

  methods: {
    sendFull() {
      this.$emit('input', this.fullCode);

      if (this.fullCode.length === this.charCount && this.autosend) {
        this.$emit('fullCode');
      }
    },

    checkInput(evt) {
      const hasValue = !!evt.target.value;
      const currentKey = evt.target.id.split('-')[1];

      if (!currentKey) {
        console.warn('Failed to fetch key', evt.target.id);
        return;
      }

      let nextKey = Math.min(parseInt(currentKey, 10) + 1, this.chars.length);

      if (!hasValue) {
        nextKey = Math.max(parseInt(currentKey, 10) - 1, 1);
      }

      if (currentKey === nextKey.toString()) return;

      this.switchFocus(`fk-${nextKey}`);
    },

    switchFocus(key) {
      const el = document.getElementById(key);
      if (el) {
        el.focus();
        el.select();
      }
    },

    selectInput(evt) {
      evt.target.select();
    },
  },
};
</script>
